import { UPLOAD_STATUS } from "../types/submission";
import type {
  SubmissionItem,
  UploadedCaptureResult,
} from "../types/submission";

export function isReadyToSubmit(
  items: SubmissionItem[],
  results: Record<string, UploadedCaptureResult>
): boolean {
  if (!items?.length) return false;

  return items.every(
    (item) =>
      item.status === UPLOAD_STATUS.done && Boolean(results?.[item.alias]?.url)
  );
}

export function getIncompleteUploadMessage(
  items: SubmissionItem[],
  results: Record<string, UploadedCaptureResult>
): string | null {
  const failed = items.filter((i) => i.status === UPLOAD_STATUS.error).length;
  const pending = items.filter(
    (i) =>
      i.status === UPLOAD_STATUS.pending || i.status === UPLOAD_STATUS.uploading
  ).length;

  if (failed > 0) {
    return `${failed} photo(s) failed to upload. Tap retry to try again.`;
  }
  if (pending > 0) {
    return `${pending} photo(s) still need to be uploaded.`;
  }
  if (!isReadyToSubmit(items, results)) {
    return "Some photos are missing upload results. Please retry.";
  }
  return null;
}
